// @TODO Implement web analytics

export const analyticsClient = {
	screen: (_name: string) => Promise.resolve(),
};

export const idfaSegmentPlugin = {
	requestTrackingPermission: () => Promise.resolve(),
};
